import React, { useState } from 'react';
import { AlertNotification, Button, InputStepper, LabeledCheckbox, Loading } from '@commonsku/styles';
import moment from 'moment';

type AdminLicensesLicensesDetailsProps = {
  state: {
    activeUsers: number,
    quantity: number
  },
  onSave: (seats: number) => Promise<void>
  company: {
    churning: string | null,
  },
};

export default function AdminLicensesLicensesDetails({
  state: {
    quantity,
    activeUsers,
  },
  onSave,
  company,
}: AdminLicensesLicensesDetailsProps) {
  const [seats, setSeats] = useState<number>(quantity);
  const [loading, setLoading] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState<boolean>(false);

  const handleOnClick = async (seats: number) => {
    setLoading(true);
    await onSave(seats);
    setLoading(false);
  };

  const content = loading ? <Loading mt={60} /> :
    <>
      <div style={{width: '320px', marginTop: '30px'}}>
        <span style={{fontWeight: 'bold'}}>Users:</span>
        <span style={{float: 'right'}}>{activeUsers}</span>
      </div>
      <div style={{width: '390px', fontWeight: 'bold', marginTop: '35px'}}>
        <span style={{fontWeight: 'bold', marginTop: '15px', display: 'inline-block'}}>Licenses:</span>
        <span style={{float: 'right'}}>
          <InputStepper
            initialValue={quantity}
            max={999}
            min={quantity}
            onChange={(value)=>{
              setSeats(parseInt(`${value}`))
            }}
            disabled={!!company.churning}
          />
        </span>
      </div>
      <div style={{marginTop: 50}}>
        <LabeledCheckbox
          label={<div>I’m authorized to make changes to our contract</div>}
          checked={acceptedTerms}
          onChange={()=>setAcceptedTerms(!acceptedTerms)}
          disabled={!!company.churning}
        />
      </div>
    </>;

  const info = !!company.churning ?
    'Your contract is ending, you cannot change your license count.' :
    'Additional licenses are committed through the end of the term.';

  return (
    <>
      <AlertNotification href='https://help.commonsku.com/knowledge/add-and-remove-users' learnMore={true} target={'_blank'}>
        {info}
      </AlertNotification>
      {content}
      <Button
        disabled={!acceptedTerms || loading || seats === quantity || !!company.churning}
        style={{position: 'absolute', bottom: '20px', right: '20px'}}
        onClick={() => {
          handleOnClick(seats)
        }}
      >Save</Button>
    </>
  );
}
